module.exports = __webpack_public_path__ + "static/media/pic_winie_05.b08f3d71.png";